<style lang="less" scoped> 
	.largeButton{
		border: 1px solid #ccc;
		border-radius: 12px;
		text-align: center;
		padding: 15px;
		height: 100%;
		display: table;
		width: 100%;
		min-height:	100px;
		cursor: pointer;
		font-size: 1.1em;
		div{
			display: table-cell;
			vertical-align: middle;
		}
		&.active{
			color: white;
			background: #86BD60;
			font-weight: bold;
		}
	}
</style>
<style lang="less"> 
	.sv_complete_btn{
		display: none !important;
	}
</style>
<template>
	<v-dialog v-model="dialog" v-if="!logged_in">
		<template v-slot:activator="{ on }">
			<v-btn v-bind="size" :color="color" dark class="ml-2 mr-2" v-on="on"><v-icon small class="mr-3">mdi-account</v-icon>Register</v-btn>       
		</template>
		<v-sheet class="pt-4">
			<v-stepper v-model="step">
				<v-stepper-header>
					<v-stepper-step :complete="step > 1" step="1">Welcome</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 2" step="2">Your Details</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="3">Complete</v-stepper-step>
				</v-stepper-header>
				<v-stepper-items>
					<v-stepper-content step="1">
						<v-card class="mb-12 pa-3" flat min-height="200px">
							<p class="title">Which of the following best describes your registration?</p>
							<v-row>
								<v-col cols="12" sm="6">
									<div class="largeButton elevation-4" @click="type = 'new'" :class="{active: type == 'new' }">
										<div>I have never signed up before</div>
									</div>
								</v-col>
								<v-col cols="12" sm="6">
									<div class="largeButton elevation-4" @click="type = 'retrieve'" :class="{active: type == 'retrieve' }">
										<div>I have received an email asking me to activate my account</div>
									</div>
								</v-col>
							</v-row>
						</v-card>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="cancel" class="mr-2">Cancel</v-btn>
							<v-btn color="primary" dark @click="step = 2" :disabled="!type">Next</v-btn>
						</v-card-actions>
					</v-stepper-content>
					<v-stepper-content step="2">
						<v-card class="mb-12 pa-3" flat min-height="200px" >
							<div v-if="type=='new'">
								<RenderSurvey :surveyContent="surveyContent"></RenderSurvey>
							</div>
							<div v-if="type=='retrieve'">
								<p class="title">Please enter your email address</p>
								<v-text-field v-model="email" label="Email Address"></v-text-field>
							</div>
						</v-card>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="cancel" class="mr-2">Cancel</v-btn>
							<v-btn color="primary" dark @click="completeSignUp" >Next</v-btn>
						</v-card-actions>
					</v-stepper-content>
					<v-stepper-content step="3">
						<v-card	class="mb-12 pa-3" flat min-height="200px">
							<div v-if="type == 'retrieve'">
								<v-progress-linear v-if="running" indeterminate color="green" class="mt-3"></v-progress-linear>
								<v-alert type="warning" outlined dense v-if="false == success">Account not found. Please contact Meisterworks</v-alert>
								<v-alert type="success" outlined dense v-if="true == success">Thank you. Please check your email for further instructions</v-alert>								
							</div> 
							<div v-if="type == 'new'">
								Thank you for answering our questions! We'll get in touch with you to let you know when we're planning new paid market research studies that might be relevant to you!
							</div> 
						</v-card>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="cancel" class="mr-2">Cancel</v-btn>
							<v-btn color="green" dark @click="cancel" >Finish</v-btn>
						</v-card-actions>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>			
		</v-sheet>			
	</v-dialog>    	
</template>


<script>
	import RenderSurvey from "@/components/RenderSurvey.vue"
	import {checkAccount, processAccountSetUp} from "../assets/accountFunctions.js"
	import Vuex from 'vuex'
	export default{
		name: "RegistrationForm", 
		props: ["size", "color"],
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				logged_in: state => state.auth.logged_in,
				user: state => state.auth.user,
				survey: state => state.registration.survey,
				id: state => state.registration.id
			}),
			surveyContent(){
				let content = {
					elements: []
				}
				let self = this;
				self.survey.elements.forEach( e => content.elements.push(e) )
				content.completedHtml = self.survey.thankYouMessage				
				content.showQuestionNumbers = self.survey.showQuestionNumbers				
				for( var key in self.survey.surveyProperties ){
					content[key] = self.survey.surveyProperties[key];
				}

				return content;
			}
		},
		components: {
			RenderSurvey
		},
		data: () => {
			return {
				dialog: false, 
				type: null,
				step: 1, 
				email: null, 
				running: false, 
				success: null
			
			}
		},
		methods: {
			cancel(){
				this.dialog = false;
				this.step = 1;
				this.type = null;
			},
			completeSurvey(){
				const self = this;
				let response = {
					status: "new",
					path: self.$route.path,
					data: window.S.data, 
					survey: this.id
				}
				if( self.user.uid ){
					response.respondent = self.user.uid; 
					response.type = "panelmember";
					self.$store.dispatch("addDoc", {
						collection: "surveyResponses", 
						data: response  
					}).then( () => {
						if( self.survey.sendToAfter ){
							self.$router.replace( self.survey.sendToAfter )
							self.$router.go();
						}
					})
					
				}
				else{
					self.$store.dispatch("addDoc", {
						collection: "visitors", 
						data: { firstSurvey: self.id }  
					}).then( (ref) => {
						response.type = "visitor";
						response.respondent = ref.id; 
						self.$store.dispatch("addDoc", {
							collection: "surveyResponses", 
							data: response  
						}).then( () => {
							self.step = 3
							
						})

					} )
				}
				
			},
			completeSignUp(){
				if( this.type == "new" ){
					this.completeSurvey();
				}
				else{
					this.step = 3;
				}
			}
		}, 
		watch: {
			step( step ){
				const self = this;
				if( step == 3 ){
					if( self.type == "retrieve" && self.email ){
						self.running = true;
						checkAccount(self.email).then( response => { 
							var id = response.data;
							processAccountSetUp(id).then((response) => {
								self.running = false
								self.success = true;
								response;
							}).catch( () => {
								self.running = false
								self.success = false;
							})
						}).catch( (e) => {
							console.log(e)
							self.running = false
							self.success = false;
						})						
					}
				}
			}
		},
		created(){
			this.$store.dispatch("registration/getSurvey")
		}
	}
</script>